import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught an error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
            padding: "20px",
            textAlign: "center",
            backgroundColor: "#1a1a1a",
            color: "#ffffff",
          }}
        >
          <h1 style={{ color: "#ef4444", marginBottom: "16px" }}>
            Something went wrong
          </h1>
          <p style={{ color: "#9ca3af", marginBottom: "24px", maxWidth: "300px" }}>
            An unexpected error occurred. Please refresh the app to try again.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: "12px 32px",
              fontSize: "16px",
              backgroundColor: "#3b82f6",
              color: "white",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
            }}
          >
            Refresh App
          </button>
          {process.env.NODE_ENV === "development" && this.state.error && (
            <pre
              style={{
                marginTop: "24px",
                padding: "16px",
                backgroundColor: "#374151",
                borderRadius: "8px",
                fontSize: "11px",
                maxWidth: "90vw",
                overflow: "auto",
                textAlign: "left",
              }}
            >
              {this.state.error.toString()}
            </pre>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
